import type { ContactSearchResult } from "@adva/types";

export function customerHrefFor(id: string): string {
  return `/customers/${id}`;
}

export function opportunityHrefFor(id: string): string {
  return `/opportunities/${id}`;
}

export function productHrefFor(id: string): string {
  return `/products/${id}`;
}

export function crewHrefFor(id: string): string {
  return `/crews/${id}`;
}

/**
 * Resolve the destination href for a contact-search hit. Mirrors the original
 * `runContact` logic in the v1 palette: prefer a customer-role membership in
 * the current business, fall back to the first membership, route team members
 * to the team-members detail, and route contacts with no membership in the
 * current business to the account-level contacts detail.
 */
export function contactHrefFor(contact: ContactSearchResult): string {
  const role = contact.has_current_business_role
    ? (contact.memberships.find(
        (m) => m.role_type === "customer" && m.business_id,
      ) ?? contact.memberships[0])
    : contact.memberships[0];

  if (role && role.role_type === "team_member") {
    return `/team-members/${contact.contact_id}`;
  }
  if (role) {
    return `/customers/${contact.contact_id}`;
  }
  return `/account/contacts/${contact.contact_id}`;
}
